import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import EditModel from "../../components/Common/editModel";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { render } from "@testing-library/react";
import { setType } from "store/actions";
function EditModelPme() {
  const { id } = useParams();
  const navigate = useNavigate();
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };

  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [modeleData, setModeleData] = useState([]);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const [tooltipOpen1, setTooltipOpen1] = useState(false);

  const toggleTooltip1 = () => {
    setTooltipOpen1(!tooltipOpen1);
  };
  const [tooltipOpen2, setTooltipOpen2] = useState(false);

  const toggleTooltip2 = () => {
    setTooltipOpen2(!tooltipOpen2);
  };
  const [tooltipOpen3, setTooltipOpen3] = useState(false);

  const toggleTooltip3 = () => {
    setTooltipOpen3(!tooltipOpen3);
  };
  const [tooltipOpen4, setTooltipOpen4] = useState(false);

  const toggleTooltip4 = () => {
    setTooltipOpen4(!tooltipOpen4);
  };
  const [tooltipOpen5, setTooltipOpen5] = useState(false);

  const toggleTooltip5 = () => {
    setTooltipOpen5(!tooltipOpen5);
  };
  const [tooltipOpen6, setTooltipOpen6] = useState(false);

  const toggleTooltip6 = () => {
    setTooltipOpen6(!tooltipOpen6);
  };
  const [tooltipOpen7, setTooltipOpen7] = useState(false);

  const toggleTooltip7 = () => {
    setTooltipOpen7(!tooltipOpen7);
  };
  const [tooltipOpen8, setTooltipOpen8] = useState(false);

  const toggleTooltip8 = () => {
    setTooltipOpen8(!tooltipOpen8);
  };
  const [tooltipOpen9, setTooltipOpen9] = useState(false);

  const toggleTooltip9 = () => {
    setTooltipOpen9(!tooltipOpen9);
  };
  const [tooltipOpen10, setTooltipOpen10] = useState(false);

  const toggleTooltip10 = () => {
    setTooltipOpen10(!tooltipOpen10);
  };
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [caracteristiqueData, setCaracteristiqueData] = useState([]);
  const [imagesData, setImagesData] = useState([]);
  const [commentaireData, setCommentaireData] = useState([]);
  const [champsImpressionData, setChampsImpressionData] = useState([]);
  const [filtresData, setFiltresData] = useState([]);
  const [presentationData, setPresentationData] = useState([]);
  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const [showData, setShowData] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_pmes/types_publipostages`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [orientationData, setOrientationData] = useState({ data: [] });

  const getOrientation = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_pmes/orientations
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setOrientationData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderOrientationOptions = () => {
    return [
      {
        options: orientationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [categoryData, setCategoryData] = useState({ data: [] });
  const getCategory = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_pmes/natures_investissements
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategoryData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategoryOptions = () => {
    return [
      {
        options: categoryData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Original *********************************/
  const [selectedOriginal, setSelectedOriginal] = useState("");
  const handleOriginalChange = (e) => {
    setSelectedOriginal(e);
  };
  /************************************* Nom modèle *********************************/
  const [selectedNomMod, setSelectedNomMod] = useState("");
  const handleNomModChange = (e) => {
    setSelectedNomMod(e.target.value);
  };
  /************************************* Fisc *********************************/
  const [selectedFisc, setSelectedFisc] = useState("");
  const handleFiscChange = (e) => {
    setSelectedFisc(e);
  };
  const [selectedListBalise, setSelectedListBalise] = useState("");

  /************************************* Transmission API *********************************/
  const [selectedTransmissionAPI, setSelectedTransmissionAPI] = useState("");
  const handleTransmissionAPIChange = (e) => {
    setSelectedTransmissionAPI(e);
  };
  /************************************* Categorie *********************************/
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };

  /************************************* Balise*********************************/
  const [selectedBalise, setSelectedBalise] = useState("");
  const handleBaliseChange = (e) => {
    setSelectedBalise(e.target.value);
  };
  /************************************* Commentaire *********************************/
  const [selectedCommentaire, setSelectedCommentaire] = useState("");
  const handleCommentaireChange = (e) => {
    setSelectedCommentaire(e.target.value);
  };
  /********************************Champs ********************************/
  const [selectedChamps1, setSelectedChamps1] = useState("");
  const [selectedChamps2, setSelectedChamps2] = useState("");
  const [selectedChamps3, setSelectedChamps3] = useState("");
  const [selectedChamps4, setSelectedChamps4] = useState("");
  const [selectedChamps5, setSelectedChamps5] = useState("");
  const [selectedChamps6, setSelectedChamps6] = useState("");

  const handleChamps1Change = (e) => {
    setSelectedChamps1(e.target.value);
  };

  const handleChamps2Change = (e) => {
    setSelectedChamps2(e.target.value);
  };

  const handleChamps3Change = (e) => {
    setSelectedChamps3(e.target.value);
  };

  const handleChamps4Change = (e) => {
    setSelectedChamps4(e.target.value);
  };

  const handleChamps5Change = (e) => {
    setSelectedChamps5(e.target.value);
  };

  const handleChamps6Change = (e) => {
    setSelectedChamps6(e.target.value);
  };
  /******************************* Images  *****************************************/
  const [selectedImage1, setSelectedImage1] = useState("");
  const [selectedImage2, setSelectedImage2] = useState("");
  const [selectedImage3, setSelectedImage3] = useState("");
  const [selectedImage4, setSelectedImage4] = useState("");

  // Change handlers for image selection
  const handleImage1Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedImage1(newFile);
    } else {
      setSelectedImage1(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleImage2Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedImage2(newFile);
    } else {
      setSelectedImage2(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleImage3Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedImage3(newFile);
    } else {
      setSelectedImage3(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const handleImage4Change = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedImage4(newFile);
    } else {
      setSelectedImage4(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  /******************************* HMF Signature électronique *******************************************/
  const [formSignature, setFormSignature] = useState({});
  const onAddFormSignature = () => {
    const modifiedSignature = [...formSignature];
    modifiedSignature.push({
      index: modifiedSignature.length + 1,
      id: null,
      page_signature: null,
      position_signature: null,
      signataire: null,
    });
    setFormSignature(modifiedSignature);
  };

  const onDeleteFormSignature = (id) => {
    var modifiedSignature = [...formSignature];
    modifiedSignature = modifiedSignature.filter((x) => x["index"] !== id);
    setFormSignature(modifiedSignature);
  };
  const handleInputChange = (index, field, value) => {
    console.log("ID:", index);
    console.log("Field:", field);
    console.log("Value:", value);

    const modifiedSignature = formSignature.map((signature) => {
      if (signature.index === index) {
        return {
          ...signature,
          [field]: value,
        };
      }
      return signature;
    });

    setFormSignature(modifiedSignature);
  };
  /******************************* END HMF Signature électronique *******************************************/

  /******************************* Présentation  *****************************************/

  const [selectedNomGlobal, setSelectedNomGlobal] = useState("");
  const handleNomGlobalChange = (e) => {
    setSelectedNomGlobal(e.target.value);
  };

  const [selectedNomIndividuel, setSelectedNomIndividuel] = useState("");
  const handleNomIndividuelChange = (e) => {
    setSelectedNomIndividuel(e.target.value);
  };

  const [selectedOrientation, setSelectedOrientation] = useState("");
  const handleOrientationChange = (e) => {
    setSelectedOrientation(e);
  };
  const [selectedFichierParOccurence, setSelectedFichierParOccurence] =
    useState("");
  const handleFichierParOccurenceChange = (e) => {
    setSelectedFichierParOccurence(e);
  };

  const [selectedMargeHaut, setSelectedMargeHaut] = useState("");
  const handleMargeHautChange = (e) => {
    setSelectedMargeHaut(e.target.value);
  };

  const [selectedMargeBas, setSelectedMargeBas] = useState("");
  const handleMargeBasChange = (e) => {
    setSelectedMargeBas(e.target.value);
  };

  const [selectedMargeCote, setSelectedMargeCote] = useState("");
  const handleMargeCoteChange = (e) => {
    setSelectedMargeCote(e.target.value);
  };

  const [selectedHauteurLigne, setSelectedHauteurLigne] = useState("");
  const handleHauteurLigneChange = (e) => {
    setSelectedHauteurLigne(e.target.value);
  };

  const [selectedHauteurPied, setSelectedHauteurPied] = useState("");
  const handleHauteurPiedChange = (e) => {
    setSelectedHauteurPied(e.target.value);
  };

  const [selectedLargeur, setSelectedLargeur] = useState("");
  const handleLargeurChange = (e) => {
    setSelectedLargeur(e.target.value);
  };
  /******************************* Contenu *******************************************/
  const [selectedContent, setSelectedContent] = useState("");
  const handleContentChange = (e) => {
    setSelectedContent(e);
    console.log("content: ", e);
  };
  const [selectedHeader, setSelectedHeader] = useState("");
  const handleHeaderChange = (e) => {
    setSelectedHeader(e.target.value);
  };
  const [selectedFooter, setSelectedFooter] = useState("");
  const handleFooterChange = (e) => {
    setSelectedFooter(e.target.value);
  };
  /// Liste balise
  const [listeData, setListeData] = useState("");

  const getListe = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages/list_tags?type_filtre_id=6`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setListeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  /******************************* Submit Edit *******************************************/
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/publipostages_pmes/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const modeleData = await response.json();
      setModeleData(modeleData);
      setCaracteristiqueData(
        modeleData?.detail_publipostage?.["Caractéristiques"]
      );
      setPresentationData(
        modeleData?.detail_publipostage?.["Présentation / sortie"]
      );
      setFiltresData(modeleData?.detail_publipostage?.["Filtres / Cumul"]);
      setChampsImpressionData(
        modeleData?.detail_publipostage?.["Champs d'impression"]
      );
      setImagesData(modeleData?.detail_publipostage?.Images);
      setCommentaireData(modeleData?.detail_publipostage?.Commentaires);
      setFormSignature(
        modeleData?.detail_publipostage?.["Signature électronique"][
          "Signataires"
        ]["data"]
      );
      setSelectedType(
        modeleData?.detail_publipostage?.["Caractéristiques"]["Document type"]
      );
      setSelectedNomMod(
        modeleData?.detail_publipostage?.["Caractéristiques"]["Nom du modèle"]
      );
      setSelectedOriginal(
        modeleData?.detail_publipostage?.["Caractéristiques"]["Original"]
      );
      setSelectedActif(
        modeleData?.detail_publipostage?.["Caractéristiques"]["Actif"]
      );
      setSelectedFisc(
        modeleData?.detail_publipostage?.["Caractéristiques"][
          "A transmettre au fisc"
        ]
      );
      setSelectedListBalise(
        modeleData?.detail_publipostage?.["Caractéristiques"][
          "Liste des balises disponibles"
        ]
      );
      setSelectedTransmissionAPI(
        modeleData?.detail_publipostage?.["Caractéristiques"][
          "Transmission API CGP"
        ]
      );
      setSelectedCategorie(
        modeleData?.detail_publipostage?.["Filtres / Cumul"]["Catégorie de PME"]
      );
      setSelectedBalise(
        modeleData?.detail_publipostage?.["Filtres / Cumul"][
          "Balises non nulle pour impression"
        ]
      );
      setSelectedCommentaire(
        modeleData?.detail_publipostage?.["Commentaires"]["Commentaires"]
      );
      setSelectedNomGlobal(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Nom du fichier global"
        ]
      );
      setSelectedNomIndividuel(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Nom des fichiers individuels"
        ]
      );
      setSelectedOrientation(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Orientation"
        ]
      );
      setSelectedFichierParOccurence(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Un fichier par occurence"
        ]
      );
      setSelectedHauteurPied(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Espace entre le footer/header et le corps (mm)"
        ]
      );
      setSelectedMargeHaut(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Marge haut (cm)"
        ]
      );
      setSelectedMargeBas(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Marge bas (cm)"
        ]
      );
      setSelectedMargeCote(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Marge côtés (cm)"
        ]
      );
      setSelectedHauteurLigne(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Hauteur de ligne (em)"
        ]
      );
      setSelectedLargeur(
        modeleData?.detail_publipostage?.["Présentation / sortie"][
          "Largeur (px)"
        ]
      );
      setSelectedChamps1(
        modeleData?.detail_publipostage?.["Champs d'impression"]["Champ 1"]
      );
      setSelectedChamps2(
        modeleData?.detail_publipostage?.["Champs d'impression"]["Champ 2"]
      );
      setSelectedChamps3(
        modeleData?.detail_publipostage?.["Champs d'impression"]["Champ 3"]
      );
      setSelectedChamps4(
        modeleData?.detail_publipostage?.["Champs d'impression"]["Champ 4"]
      );
      setSelectedChamps5(
        modeleData?.detail_publipostage?.["Champs d'impression"]["Champ 5"]
      );
      setSelectedChamps6(
        modeleData?.detail_publipostage?.["Champs d'impression"]["Champ 6"]
      );
      setSelectedImage1(modeleData?.detail_publipostage?.["Images"]["Image 1"]);
      setSelectedImage2(modeleData?.detail_publipostage?.["Images"]["Image 2"]);
      setSelectedImage3(modeleData?.detail_publipostage?.["Images"]["Image 3"]);
      setSelectedImage4(modeleData?.detail_publipostage?.["Images"]["Image 4"]);
      setSelectedContent(modeleData?.detail_publipostage?.["Contenu"]["Corps"]);
      setSelectedHeader(modeleData?.detail_publipostage?.["Contenu"]["Header"]);
      setSelectedFooter(modeleData?.detail_publipostage?.["Contenu"]["Footer"]);
    } catch (error) {
      console.error(error);
    }
  };

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Modèles PME
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/publipostages_pmes/show_a_imprimer?id=${id}&types_publipostage_id=${selectedType?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setShowData(data);
          console.log(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("header", selectedHeader);
      formData.append("corps", selectedContent);
      formData.append("nom", selectedNomMod);
      formData.append("footer", selectedFooter);
      formData.append("nom_sortie", selectedNomIndividuel);
      formData.append("image_1", selectedImage1);
      formData.append("image_2", selectedImage2);
      formData.append("image_3", selectedImage3);
      formData.append("image_4", selectedImage4);
      formData.append("orientation_id", selectedOrientation?.value || "");
      formData.append("vertical_margin", selectedMargeHaut);
      formData.append("horizontal_margin", selectedMargeCote);
      formData.append("commentaires", selectedCommentaire);
      formData.append(
        "fichier_par_investisseur",
        selectedFichierParOccurence?.value || ""
      );

      formData.append("champ_1", selectedChamps1);
      formData.append("champ_2", selectedChamps2);
      formData.append("champ_3", selectedChamps3);
      formData.append("champ_4", selectedChamps4);
      formData.append("champ_5", selectedChamps5);
      formData.append("champ_6", selectedChamps6);
      formData.append("types_publipostage_id", selectedType?.value || "");
      formData.append("hauteur_de_ligne", selectedHauteurLigne);
      formData.append(
        "natures_investissement_id",
        selectedCategorie?.value || ""
      );
      formData.append("balises_non_nulle_pour_impression", selectedBalise);
      formData.append("actif", selectedActif?.value || "");
      formData.append("original", selectedOriginal?.value || "");
      formData.append("nom_du_fichier_global", selectedNomGlobal);
      formData.append("largeur_px", selectedLargeur);
      formData.append("footer_spacing", selectedHauteurPied);
      formData.append("footer_margin", selectedMargeBas);
      formData.append("a_imprimer", selectedFisc?.value || "");
      formData.append(
        "transmission_api_cgp",
        selectedTransmissionAPI?.value || ""
      );
      formData.append(
        "publipostage_hmf_signataires",
        JSON.stringify(
          formSignature.map((obj) => {
            const { index, ...rest } = obj;
            return rest;
          })
        )
      );
      const response = await fetch(
        `https://www.fluxod.com/${api}/publipostages_pmes/${id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");

        handleNavigate({ key: true });
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();
        if (
          (responseData && responseData.societe_validation) ||
          (responseData && responseData.publipostage_validation)
        ) {
          // Si le champ "societe_validation" est présent dans la réponse JSON
          const errors =
            responseData.societe_validation[0] ||
            responseData?.publipostage_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  return (
    <>
      <React.Fragment>
        <EditModel
          setContent={setSelectedContent}
          showData={showData?.data}
          getShow={getShow}
          fetchData={fetchData}
          getType={getType}
          getOrientation={getOrientation}
          getCategory={getCategory}
          getListe={getListe}
          listeData={listeData?.message}
          handleSubmit={handleSubmit}
          api={"publipostages_pmes"}
          backUrl={backUrl}
          CustomNavTabs={CustomNavTabs}
          colStyle={colStyle}
          activeTab={activeTab}
          toggleTooltip={toggleTooltip}
          tooltipOpen={tooltipOpen}
          toggleTooltip1={toggleTooltip1}
          tooltipOpen1={tooltipOpen1}
          toggleTooltip2={toggleTooltip2}
          tooltipOpen2={tooltipOpen2}
          toggleTooltip3={toggleTooltip3}
          toggleTooltip4={toggleTooltip4}
          toggleTooltip5={toggleTooltip5}
          toggleTooltip6={toggleTooltip6}
          toggleTooltip7={toggleTooltip7}
          toggleTooltip8={toggleTooltip8}
          toggleTooltip9={toggleTooltip9}
          toggleTooltip10={toggleTooltip10}
          tooltipOpen3={tooltipOpen3}
          tooltipOpen4={tooltipOpen4}
          tooltipOpen5={tooltipOpen5}
          tooltipOpen6={tooltipOpen6}
          tooltipOpen7={tooltipOpen7}
          tooltipOpen8={tooltipOpen8}
          tooltipOpen9={tooltipOpen9}
          tooltipOpen10={tooltipOpen10}
          Titre={modeleData?.sil}
          TitrePage={"Modèles PME"}
          modelData={modeleData}
          // Rendu
          renderOrientationOptions={renderOrientationOptions}
          renderOuiNonOptions={renderOuiNonOptions}
          renderTypeOptions={renderTypeOptions}
          renderCategorieOptions={renderCategoryOptions}
          // Handlers
          handleActifChange={handleActifChange}
          handleFiscChange={handleFiscChange}
          handleNomModChange={handleNomModChange}
          handleOriginalChange={handleOriginalChange}
          handleTypeChange={handleTypeChange}
          handleTransmissionAPIChange={handleTransmissionAPIChange}
          handleCategorieChange={handleCategorieChange}
          handleBaliseChange={handleBaliseChange}
          handleCommentaireChange={handleCommentaireChange}
          handleChamps1Change={handleChamps1Change}
          handleChamps2Change={handleChamps2Change}
          handleChamps3Change={handleChamps3Change}
          handleChamps4Change={handleChamps4Change}
          handleChamps5Change={handleChamps5Change}
          handleChamps6Change={handleChamps6Change}
          handleHauteurLigneChange={handleHauteurLigneChange}
          handleHauteurPiedChange={handleHauteurPiedChange}
          handleImage1Change={handleImage1Change}
          handleImage2Change={handleImage2Change}
          handleImage3Change={handleImage3Change}
          handleImage4Change={handleImage4Change}
          handleLargeurChange={handleLargeurChange}
          handleMargeBasChange={handleMargeBasChange}
          handleMargeCoteChange={handleMargeCoteChange}
          handleMargeHautChange={handleMargeHautChange}
          handleNomGlobalChange={handleNomGlobalChange}
          handleNomIndividuelChange={handleNomIndividuelChange}
          handleOrientationChange={handleOrientationChange}
          handleFichierParOccurenceChange={handleFichierParOccurenceChange}
          // Variables
          selectedType={selectedType}
          selectedActif={selectedActif}
          selectedFisc={selectedFisc}
          selectedOriginal={selectedOriginal}
          selectedNomMod={selectedNomMod}
          selectedTransmissionAPI={selectedTransmissionAPI}
          selectedCategorie={selectedCategorie}
          selectedBalise={selectedBalise}
          selectedCommentaire={selectedCommentaire}
          selectedChamps1={selectedChamps1}
          selectedChamps2={selectedChamps2}
          selectedChamps3={selectedChamps3}
          selectedChamps4={selectedChamps4}
          selectedChamps5={selectedChamps5}
          selectedChamps6={selectedChamps6}
          selectedImage1={selectedImage1}
          selectedImage2={selectedImage2}
          selectedImage3={selectedImage3}
          selectedImage4={selectedImage4}
          //
          selectedHauteurLigne={selectedHauteurLigne}
          selectedHauteurPied={selectedHauteurPied}
          selectedMargeBas={selectedMargeBas}
          selectedMargeHaut={selectedMargeHaut}
          selectedNomGlobal={selectedNomGlobal}
          selectedNomIndividuel={selectedNomIndividuel}
          selectedOrientation={selectedOrientation}
          selectedFichierParOccurence={selectedFichierParOccurence}
          selectedMargeCote={selectedMargeCote}
          selectedLargeur={selectedLargeur}
          // Signature
          formSignature={formSignature}
          onAddFormSignature={onAddFormSignature}
          onDeleteFormSignature={onDeleteFormSignature}
          handleInputChange={handleInputChange}
          // Contenu
          selectedContent={selectedContent}
          handleContentChange={handleContentChange}
          selectedHeader={selectedHeader}
          selectedFooter={selectedFooter}
          handleFooterChange={handleFooterChange}
          handleHeaderChange={handleHeaderChange}
          // Données variables
          CaracteristiqueData={caracteristiqueData}
          ImagesData={imagesData}
          CommentaireData={commentaireData}
          ChampsImpressionData={champsImpressionData}
          FiltresData={filtresData}
          PresentationData={presentationData}
        />
      </React.Fragment>
    </>
  );
}

export default EditModelPme;
